import axios from "axios";

import {Authentication} from "../../Types/teams";
import {getPlatformUrl} from "../../utils";

export default class TeamsAuthClient {

  static async authenticate(email: string, password: string): Promise<Authentication> {
    const url = `${getPlatformUrl()}/teams-repository/oauth2/token?tenant=leanspace`;
    const response = await axios.post(url, new URLSearchParams().toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": `Basic ${btoa(`${email}:${password}`)}`
      }
    });
    return response.data as Authentication;
  }

  static async refresh(email: string, refreshToken: string): Promise<Authentication> {
    const url = `${getPlatformUrl()}/teams-repository/oauth2/token?tenant=leanspace`;
    const request = new URLSearchParams({
      refresh_token: refreshToken,
      principal: email
    });
    const response = await axios.post(url, request.toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    });
    return response.data as Authentication;
  }

}
